import { css } from 'styled-components';
import { CSSDefaultInput } from '../inputs/InputCommon.js';
import { CSSGenerateTextFieldError } from '../styles/cssGenerateField.js';
import { FIELD_ERROR_DATA_ATTRIBUTE } from './FieldError.js';

const CSSDefaultInputField = css`
  ${CSSDefaultInput}

  [${FIELD_ERROR_DATA_ATTRIBUTE}] > &,
  [${FIELD_ERROR_DATA_ATTRIBUTE}] > &:hover,
  [${FIELD_ERROR_DATA_ATTRIBUTE}] > &:focus {
    ${CSSGenerateTextFieldError()}
  }
`;

export { CSSDefaultInputField };
